import LanguageBalloon from "./LanguageBalloon";
import {useState, useEffect} from 'react';

export default props=>{
	const [display, setDisplay]=useState('none');
    const [vLang, setLang] = useState('none');

    useEffect(() => {
        setLang(localStorage['NLS']);
        return () => { ; }
    }, []);

    useEffect(() => {
        if (vLang=='none') return;
        localStorage['NLS'] = vLang;
        return ()=>{;}
    }, [vLang]);

    if (process.browser) window.unsets.upperLanguage = () => setDisplay("none");

	const jsx = (<div className="dib">
		<style jsx>{`
.this-binder {
    vertical-align: middle;
}

.this-binder>div {
    vertical-align: middle;
}

.korean{
    margin:0 8px;
}

.m-down{
    width:22px;
}

@media all and (max-width:606px) {
    .this-binder {
        vertical-align: middle;
    }

    .this-binder>div {
        vertical-align: middle;
    }

    .korean{
        color: white;
    }

}
`}</style>

        <a className="upperLanguage" onClick={e=> (display == 'none')? setDisplay('block'):setDisplay('none')}>
            <div className="this-binder dib" >
                <div className="dib">
                    <img className="dib" src={`/assets/images/flag-${vLang == 'vietnam' ? "vietnam" : "korea"}@2x.png`}/>
                </div>
                <div className="dib korean" >{vLang == 'vietnam' ? "Vietnam" : "Korean" }</div>
                <div className="dib">
                    <img className="dib dnom" src="/assets/images/group-11-copy-3.svg" />
                    <img className="dib dibom m-down" src="/assets/images-m/down.svg" />
                </div>
            </div>
        </a>

        <LanguageBalloon display={display} vLang={vLang} setLang={setLang} hide={() => setDisplay('none')} />




	</div>);
	return(jsx);
}
